<template>
    <div>
        
        <Hero />
        <Feature />
        <Service />
        <Statistics />
        <Review />
        <Warranty />
        <!-- <Vehicles /> -->
        <!-- <Quote /> -->

    </div>
</template>


<script>
import Hero from './components/Hero';
import Service from './components/Service';
import Feature from './components/Feature';
import Statistics from './components/Statistics';
import Review from './components/Review';
import Warranty from './components/Warranty';
import Vehicles from './components/Vehicles';
import Quote from './components/Quote';

export default {
    components: {
        Hero,
        Service,
        Feature,
        Statistics,
        Review,
        Warranty,
        Vehicles,
        Quote
    }
}
</script>